export default {
  common: {
    done: 'Done',
    term: 'Term',
    year: 'Year | Years',
    years: 'Years',
    month: 'Month | Months',
    monthly: 'Monthly',
    annually: 'Annually',
    mo: '/Mo',
    yr: '/Yr',
    quantity: 'Quantity',
    add: 'Add',
    loading: 'Loading',
    error: "Please correct the errors or <a  class='link-info'>remove</a> the item from your cart.",
    domain: 'Domain',
    edit: 'Edit',
    account: 'Account',
    accounts: 'Accounts',
    zone: 'Zone',
    zones: 'Zones',
    relay: 'Relay',
    relays: 'Relays',
    enter_domain: 'Enter a Domain',
    hostnames: 'Hostnames',
    term_callout: 'Need a longer term length?',
    select_term: 'Select Your Term',
    length: '{hostcount}',
    recommended: 'Recommended',
    save: 'Save',
    includes: 'Includes',
    adjusting_preview: 'Adjusting Preview',
    coupon_code_is_not_valid: 'Coupon Code is not valid.',
    contact_support_if_you_believe_this_is_an_error: 'Contact support if you believe this is an error.',
    coupon_applied: 'Coupon Applied',
    sub_total: 'Sub Total',
    available_credit: 'Available credit',
    credit_used: 'Credit used',
    coupon_code_will_be_applied_once_logged_in: 'Coupon code will be applied once logged in.'
  },
  errors: {
    invalid_domain: 'Sorry, the domain you entered is invalid'
  },
  topnav: {
    planbuilder: 'Plan Builder',
    payment: 'Payment',
    orderconfirmation: 'Order Confirmation'
  },
  plan_builder: {
    undo: 'Undo',
    item_removed: 'A service has been removed from your cart.',
    select_term: '<span class="text-semibold">Select a Term</span> for your subscription',
    years: 'years',
    apply: 'Apply',
    total: 'Total',
    proceed_to_checkout: 'Proceed to Checkout',
    removed_items: 'The following service(s) have been removed from your cart because you already have an active subscription for these product(s):',
    billing_management: 'Please visit the <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Billing Management</a> page if you would like to renew them.',
    open_invoice: 'You have open invoice for the service(s) already in your cart which have been removed.',
    invoice_link: 'Please go to <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Billing Management</a>. and pay these invoices to resume your services(s).',
    empty_cart: 'Your Cart is Empty',
    purchase_services: 'Check out all the services you can purchase on <a href="/" class="text-info text-decoration-none">No-IP</a>',
    updated_enhanced_item: 'You currently have <span class="text-semibold">{hostcount} hostnames</span> and this exceeds, <span class="text-semibold">{itemtitle} {itemoptionsquantity} Hostname(s)</span>. We’ve updated your cart to go to the next available subscription, <span class="text-semibold">{newitemtitle} {newitemoptionsquantity} Hostnames</span>.',
    pro_removed_conflict: 'The following service(s) have been removed from your cart because you already have an active subscription for these product(s):',
    pro_removed_conflict_link: 'Please contact <a href="/ticket">Customer Support</a> for assistance.'
  },
  account: {
    create_an_account: 'Create an Account',
    have_an_account: 'Have an Account',
    create_account: 'Create Account',
    log_in: 'Log In',
    email: 'Email',
    user_password: 'Password',
    tos: "I agree to the <a href='/legal/tos'>Terms of Service</a> and <a href='/legal/privacy'>Privacy Policy</a>.",
    newsletter: 'Send me newsletters & special offers',
    login: 'Log In',
    email_username: 'Email or Username',
    forgotpassword: 'Forgot Password?',
    login_continue: 'Log In & Continue',
    auth_failure: 'Username / Password combination is incorrect. Please try again.',
    too_many_attempts: 'Your IP address has submitted this form too many times recently. Please wait a few minutes before trying again.',
    too_many_attempts: 'Your account has been locked due to excessive password entry failures. The account will be unlocked in 15 minutes at which time you can try logging in again. You can also call 1-877-367-6647 during office hours: 6:30am - 5:30 pm Pacific Time Monday-Friday to have your account unlocked immediately. This is a security feature to prevent brute force login attempts. If you have forgotten your password, use our forgot password form to have a reset password link sent to you. Then retry your login in 15 minutes.',
    captcha_failure: 'reCAPTCHA failed, you will need to successfully complete reCAPTCHA before logging in.',
    newsletter: 'Send me newsletters & special offers',
    create_account: 'Create Account',
    logged_in_as: 'Logged In as',
    create_an_account: 'Need to Create an Account?',
    already_have_an_account: 'Already have an Account?',
    sign_up_with_google: 'Sign Up with Google',
    sign_in_with_google: 'Sign In with Google',
    sign_up_with_microsoft: 'Sign Up with Microsoft',
    sign_in_with_microsoft: 'Sign In with Microsoft'
  },
  domain_input: {
    tooltip: 'Enter a domain that you own to use with this service. Note: This will not register the domain.'
  },
  domain_reg: {
    tooltip: 'Register your domain with No-IP an ICANN accredited registrar.'
  },
  account_enhanced: {
    tooltip: 'Remote Access a computer, device or network without worrying about monthly hostname confirmations.',
    hostnames: 'Hostnames'
  },
  support_priority: {
    tooltip: 'A priority response support channel that is staffed with our friendly and experienced Technical Support team. Your ticket or support call is put to the front of the line, so you get help when you need it most.'
  },
  dns_tier: {
    tooltip: 'Fast and reliable DNS for your domain, backed by our robust Anycast network with 100+ points of presence located across the globe.'
  },
  dns_squared: {
    tooltip: 'Maximize uptime and increase reliability using your existing DNS infrastructure.'
  },
  mail_backupmx: {
    tooltip: "Backup MX gives you peace of mind. If your mail server goes down, you won't lose important email."
  },
  mail_reflector: {
    tooltip: 'Run your own mail server even if your ISP blocks port 25'
  },
  mail_pop: {
    tooltip: 'POP3/IMAP is the ideal option for those who do not want the headache of managing their own email server.'
  },
  mail_forwarding: {
    tooltip: 'Mail Forwarding enables you to receive email for your domain and have it forward to an existing account.'
  },
  mail_smtp: {
    tooltip: "SMTP is for admins that have a blocked port 25 or road warriors that don't want to change SMTP settings."
  },
  ssl_rapid: {
    tooltip: 'Secures a single domain with strong encryption. It is issued within minutes, helping you develop and launch a secure site quickly.'
  },
  ssl_rapid_dv: {
    tooltip: 'Secures a single domain with strong encryption. It is issued within minutes, helping you develop and launch a secure site quickly.'
  },
  ssl_premium: {
    tooltip: 'Provides comprehensive authentication procedures (domain name and identity verification) with a high warranty making this certificate perfect for securing your professional domain.'
  },
  ssl_rapid_wildcard: {
    tooltip: 'Secure unlimited sub-domains with strong encryption. Certificates are issued within minutes and are the most cost-effective way to secure multiple domains.'
  },
  ssl_rapid_wildcard_dv: {
    tooltip: 'Secure unlimited sub-domains with strong encryption. Certificates are issued within minutes and are the most cost-effective way to secure multiple domains.'
  },
  ssl_trustcor_standard: {
    tooltip: 'Secures a single hostname with strong encryption. It is issued within minutes, helping you develop and launch a secure site quickly.'
  },
  ssl_trustcor_premium: {
    tooltip: 'Secures a single hostname with strong encryption. It is issued within minutes, helping you develop and launch a secure site quickly.'
  },
  ssl_trustcor_wildcard: {
    tooltip: 'Secure unlimited sub-domains with strong encryption. Certificates are issued within minutes and are the most cost-effective way to secure multiple domains.'
  },
  monitor_basic: {
    tooltip: 'Having a server go down is one thing, not knowing about it is even worse. Get alerted instantly when there is a problem.'
  },
  monitor_advanced: {
    tooltip: '24/7 server monitoring including automatic failover. Automatically have your DNS settings point to your backup server or custom page on the fly.'
  },
  team_login: {
    tooltip: 'Team Login allows you to coordinate seamlessly with different logins affiliated with your account.'
  },
  registration_domain: {
    tooltip: 'Register your domain with No-IP an ICANN accredited registrar.',
    bundle_discount: 'Bundle Discount',
    you_saved: 'You Saved',
    hide_info: 'Yes, hide my personal informaton from the world for',
    no_thanks: 'No, thanks',
    private_registration_no: 'Private Registration - No'
  },
  registration_transfer: {
    tooltip: 'Transfer your domain from another registrar to No-IP.'
  },
  registration_privacy: {
    tooltip: 'Private Registration keeps your domain contact information private. We set up a proxy that handles the spam and forwards you what you need.',
    private_registration: 'Private Registration'
  },
  host_redemption: {
    tooltip: 'Recover your hostname from Redemption and keep the same configuration you had prior to Redemption.'
  },
  dns_pro: {
    tooltip: 'Create hostnames on your own domain or use a No-IP owned domain with Professional grade Dynamic DNS that scales with your needs.'
  },
  domain_contact: {
    contact: {
      oganization: 'Organization',
      email_address: 'Email Address',
      first_name: 'First Name',
      last_name: 'Last Name',
      address: 'Address',
      address2: 'Address 2',
      country: 'Country',
      state_province: 'State / Province',
      city: 'City',
      postal_zip: 'Postal/Zip',
      phone_number: 'Phone Number'
    },
    contact_form: {
      domain_contact: 'Domain Contact',
      domain_contact_text: 'Domain Registration requires valid domain contact information in order to be registered. This means that your personal name and contact details will be publicly available in the WHOIS registry. If you added Private Registration, the record will show our information instead of yours. Don’t worry about missing anything, we will forward all the important stuff to you.',
      add_private_reg: 'Add Private Registration Now',
      existing_domain_contact: 'Use an existing Domain Contact',
      new_domain_conact: 'Create a new Domain Contact',
      verifying: 'Verifying',
      continue: 'Continue',
      an_unexpected_error: "Sorry, we have encounted an unexpected error, try again in a few minutes. If this error keeps occurring, please report it in a <a href='/ticket'>support ticket</a> with your contact details."
    },
    order_summary: {
      order_summary: 'Order Summary',
      edit: 'Edit'
    }
  },
  upsell: {
    add_to_cart: 'Add to Cart',
    plus_description: 'Fully customized Dynamic DNS by creating an easy to remember hostname on your own domain.',
    enhanced_description: 'Create an easy to remember hostname to access your device remotely and never worry about confirming your hostname as long as your subscription stays active.',
    priority_description: 'No-IP Priority Support is a priority response support channel that is staffed with our friendly and experienced Technical Support team. Priority Support allows you to get the support you need as quickly as possible.',
    rapid_description: 'RapidSSL Basic DV Certificates secure a single domain with strong encryption. It is issued within minutes, helping you develop and launch a secure website quickly. It’s a quick, inexpensive way to secure your website.',
    rapid_wildcard_description: 'RapidSSL Wildcard Certificates secure unlimited sub domains with strong encryption. Certificates are issued within minutes and are the most cost effective way to secure multiple domains.',
    team_login_description: 'Team Login allows you to invite additional team members to your account. Allow your team members to help you get more done with managing customers, subscriptions and more.',
    team_login_tooltip: 'Each No-IP Account comes with one account owner. Need another login? Add a Team Member to your account.',
    per_team_member: 'per Team Member',
    recommended: 'Recommended'
  }
};
